import { create } from 'zustand';

import { ObjectItem } from 'api/clients/types';

interface ManageObjectModalV2State {
  isOpen: boolean;
  id?: number;
  company?: number;
  object?: ObjectItem;
  onManageObjectModalV2Close: () => void;
  onManageObjectModalV2Open: (id?: number, object?: ObjectItem, company?: number) => void;
  currentTab: 'clientCreation' | 'technicianCreation' | 'ownerCreation';
  setCurrentTab: (tab: 'clientCreation' | 'technicianCreation' | 'ownerCreation') => void;
}

export const useManageObjectModalV2Store = create<ManageObjectModalV2State>(set => ({
  isOpen: false,
  id: undefined,
  company: undefined,
  object: undefined,
  currentTab: 'clientCreation',
  setCurrentTab: (tab: 'clientCreation' | 'technicianCreation' | 'ownerCreation') => set({ currentTab: tab }),
  onManageObjectModalV2Close: () => set({ isOpen: false, id: undefined, object: undefined }),
  onManageObjectModalV2Open: (id?: number, object?: ObjectItem, company?: number) =>
    set({ isOpen: true, id, object, company }),
}));
